import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { provideToastr } from 'ngx-toastr';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
//import { NoCacheInterceptor } from './core/interceptors/no-cache.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [provideClientHydration(withHttpTransferCacheOptions({
    includePostRequests: true
  })), provideAnimations(), provideRouter(routes, withComponentInputBinding()),
  provideToastr({
    maxOpened: 1,
    preventDuplicates: true,
    positionClass: 'toast-top-center',
  }),
  provideNoopAnimations(),
  provideHttpClient(withFetch(), withInterceptorsFromDi()),

  TranslateModule.forRoot({
    defaultLanguage: 'en',
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient],
    },
  }).providers!,
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    //{ provide: HTTP_INTERCEPTORS, useClass: NoCacheInterceptor, multi: true }
  ]
};
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
